import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { isDevelopmentMode, sendRequest } from "../../services/base";
import { useSearchParams } from "react-router-dom";
import { getCommoditiesList } from "../../services/commodities";
import { toPersianNum } from "../../utils/persianNumbers";
const req = isDevelopmentMode() ? "/market-trades/offers" : "/trade/offer/";
let resultInterval;
export default function OfferList({
  activeOffer,
  orderList,
  activeOrder = null,
  filterType,
  filterAmount,
  filterRange,
  activeTable = null,
  initAmount = null,
  setActiveTable = null,
  selectedCommodity = null,
}) {
  const [searchParams] = useSearchParams();
  const [initial, setInitial] = useState(null);
  const [offerbuy, setOfferBuy] = useState([]);
  const [offersell, setOfferSell] = useState([]);
  const [showBuy, setShowBuy] = useState(true);
  const [showSell, setShowSell] = useState(true);
  const [reqUrl, setReqUrl] = useState(req);
  const [commodities, setCommodities] = useState([]);
  function requestHandleGetCoin() {
    if (
      (selectedCommodity.id &&
        !isNaN(Number(selectedCommodity.id)) &&
        Number(selectedCommodity.id) >= 0) ||
      !searchParams.get("commodity_id") ||
      (reqUrl.indexOf("commodity_id=") >= 0 &&
        !isNaN(reqUrl.split("commodity_id=")[1]))
    ) {
      sendRequest(reqUrl).then((res) => {
        if (res.status == 200) {
          if (res.data && res.data.results) {
            let buy = res.data.results.filter((data) => data.type == 0);
            let sell = res.data.results.filter((data) => data.type == 1);
            if (initial && initial.type) {
              if (initial.type === "buy") {
                let b = sell.filter((data) => data.id == initial.order)[0];
                activeOffer("buy");
                if (orderList) {
                  orderList(b);
                }
                setActiveTable(2);
                setOfferBuy(buy);
                setOfferSell(sell);
                setInitial(null);
              } else if (initial.type === "sell") {
                let s = buy.filter((data) => data.id == initial.order)[0];
                activeOffer("sell");
                if (orderList) {
                  orderList(s);
                }
                setActiveTable(1);
                setInitial(null);
                setOfferSell(sell);
                setOfferBuy(buy);
              } else {
                setOfferBuy(buy);
                setOfferSell(sell);
              }
            } else {
              if (reqUrl.indexOf("type=0") >= 0) {
                setOfferBuy(buy);
                setActiveTable(1);
              } else if (reqUrl.indexOf("type=1") >= 0) {
                setOfferSell(sell);
                setActiveTable(2);
              } else {
                setOfferBuy(buy);
                setOfferSell(sell);
              }
            }
          }
        } else {
          toast.error(res.data.detail);
        }
      });
    }
  }
  useEffect(() => {
    if (initAmount) {
      setInitial({ ...initAmount });
    }
  }, [initAmount]);
  useEffect(() => {
    if (
      reqUrl.indexOf("commodity_id=") >= 0 &&
      !isNaN(reqUrl.split("commodity_id=")[1])
    )
      requestHandleGetCoin();
    try {
      clearInterval(resultInterval);
    } catch (e) {}
    resultInterval = setInterval(() => {
      if (
        reqUrl.indexOf("commodity_id=") >= 0 &&
        !isNaN(reqUrl.split("commodity_id=")[1])
      ) {
        requestHandleGetCoin();
      }
    }, 10000);
    return () => {
      try {
        clearInterval(resultInterval);
      } catch (e) {}
    };
  }, [reqUrl, initAmount]);

  useEffect(() => {
    let object = {};
    if (!isNaN(activeOrder) && activeOrder !== null) {
      object.ordering = activeOrder;
    }
    if (
      !isNaN(filterType) &&
      filterType !== null &&
      (filterType === 0 || filterType === 1)
    ) {
      object.type = filterType;
    }
    if (!isNaN(filterAmount) && filterAmount !== null && filterAmount > 0) {
      object.offered_quantity = filterAmount;
    }
    if (
      Array.isArray(filterRange) &&
      filterRange[0] !== null &&
      !isNaN(filterRange[0])
    ) {
      object.offered_price__gte = filterRange[0];
    }
    if (
      Array.isArray(filterRange) &&
      filterRange[1] !== null &&
      !isNaN(filterRange[1])
    ) {
      object.offered_price__lte = filterRange[1];
    }
    if (
      selectedCommodity.id &&
      !isNaN(selectedCommodity.id) &&
      selectedCommodity.id >= 0
    ) {
      object.commodity_id = selectedCommodity.id;
    } else if (selectedCommodity.id === null) {
      object.commodity_id = "1";
    }
    if (Object.keys(object).length > 0) {
      const u = new URLSearchParams(object).toString();
      setReqUrl(req + "?" + u);
    } else {
      setReqUrl(req);
    }
  }, [
    activeOrder,
    filterAmount,
    filterType,
    filterRange,
    selectedCommodity.id,
  ]);
  useEffect(() => {
    if (initial) {
      if (initial.type === "buy") {
        let buyy = offersell.filter((data) => data.id == initial.order)[0];
        activeOffer(initial.type);
        if (buyy) {
          orderList(buyy);
        }
        if (Array.isArray(offerbuy) && offerbuy.length > 0) {
          setInitial(null);
        }
      } else if (initial.type === "sell") {
        let selll = offerbuy.filter((data) => data.id == initial.order)[0];
        activeOffer(initial.type);
        if (selll) {
          orderList(selll);
        }
        if (Array.isArray(offersell) && offersell.length > 0) {
          setInitial(null);
        }
      }
    }
  }, [initial, offerbuy, offersell]);
  useEffect(() => {
    getCommoditiesList().then((data) => {
      setCommodities(data?.data?.results || []);
    });
  }, []);
  function handleItemSelectSell(id) {
    let sell = offersell.filter((data) => data.id == id)[0];
    if (activeOffer) {
      activeOffer("buy");
    }
    if (orderList) {
      orderList(sell);
    }
  }

  function handleItemSelectBuy(id) {
    let buy = offerbuy.filter((data) => data.id == id)[0];
    if (activeOffer) {
      activeOffer("sell");
    }
    if (orderList) {
      orderList(buy);
    }
  }

  return (
    <>
      <div className="offer-list-on-bazaar-container">
        {(activeTable === 2 || activeTable === null) && (
          <div className="offer-list-on-bazaar">
            <div>
              <div
                className="sell-title-offer"
                onClick={() => {
                  activeOffer("buy");
                  setShowSell(!showSell);
                }}
              >
                <div className="table-mobile-title">پیشنهاد فروش کاربران</div>
                <div className="caret-down-item">
                  {showSell ? (
                    <img
                      src={"/images/svg/caret-down.svg"}
                      alt={"caret-down"}
                    />
                  ) : (
                    <img
                      className="rotate-caret"
                      src={"/images/svg/caret-down.svg"}
                      alt={"caret-down"}
                    />
                  )}
                </div>
              </div>
              <div className="table-header-price">
                <div>مقدار</div>
                <div>قیمت به تومان</div>
              </div>
              {Array.isArray(offersell) && offersell.length > 0 && showSell
                ? offersell.map((li, index) => (
                    <div
                      key={`sell-id-${index}`}
                      className="row-for-offer-item-list"
                      onClick={() => handleItemSelectSell(li["id"])}
                    >
                      <div id={li["id"]} className="col-6 text-right">
                        <span
                          id={li["id"]}
                          className="offer-list-text existance-color-text"
                          style={{
                            color: commodities.find(
                              (el) => el.id == li["commodity"]["id"]
                            )?.ui_data?.colors?.primary,
                          }}
                        >
                          <>
                            <img
                              width={15}
                              className="icon-sandogh"
                              src={
                                commodities.find(
                                  (el) => el.id == li["commodity"]["id"]
                                )?.ui_data?.icons?.primary
                              }
                            />
                            {new Intl.NumberFormat("fa").format(
                              li["offered_quantity"]
                            )}{" "}
                            {`${
                              selectedCommodity?.ui_data?.unit_name == null
                                ? " گرم "
                                : selectedCommodity?.ui_data?.unit_name
                            }`}{" "}
                            {` ${toPersianNum(selectedCommodity.name)}`}
                          </>
                        </span>
                      </div>

                      <div className="col-6 text-left offer-list-text">
                        <span className="">
                          {new Intl.NumberFormat("fa").format(
                            li["offered_price"]
                          )}
                          {" تومان "}
                        </span>
                      </div>
                    </div>
                  ))
                : showSell && (
                    <div className="no-order-accepted">
                      هیچ سفارشی ثبت نشده است
                    </div>
                  )}
            </div>
          </div>
        )}
        {(activeTable === 1 || activeTable === null) && (
          <div className="offer-list-on-bazaar mt-3">
            <div>
              <div
                className="sell-title-offer"
                onClick={() => {
                  activeOffer("sell");
                  setShowBuy(!showBuy);
                }}
              >
                <div className="table-mobile-title">پیشنهاد خرید کاربران</div>
                <div className="caret-down-item">
                  {showBuy ? (
                    <img
                      src={"/images/svg/caret-down.svg"}
                      alt={"caret-down"}
                    />
                  ) : (
                    <img
                      className="rotate-caret"
                      src={"/images/svg/caret-down.svg"}
                      alt={"caret-down"}
                    />
                  )}
                </div>
              </div>
              <div className="table-header-price">
                <div>مقدار</div>
                <div>قیمت به تومان</div>
              </div>
              {Array.isArray(offerbuy) && offerbuy.length > 0 && showBuy
                ? offerbuy.map((li, index) => (
                    <div
                      key={`buy-id-${index}`}
                      id={li["id"]}
                      className="row-for-offer-item-list"
                      onClick={() => handleItemSelectBuy(li["id"])}
                    >
                      <div className="col-6 text-right">
                        <span
                          id={li["id"]}
                          className="offer-list-text existance-color-text"
                          style={{
                            color: commodities.find(
                              (el) => el.id == li["commodity"]["id"]
                            )?.ui_data?.colors?.primary,
                          }}
                        >
                          <>
                            <img
                              width={15}
                              className="icon-sandogh"
                              src={
                                commodities.find(
                                  (el) => el.id == li["commodity"]["id"]
                                )?.ui_data?.icons?.primary
                              }
                            />
                            {new Intl.NumberFormat("fa").format(
                              li["offered_quantity"]
                            )}{" "}
                            {`${
                              selectedCommodity?.ui_data?.unit_name == null
                                ? " گرم "
                                : selectedCommodity?.ui_data?.unit_name
                            }`}{" "}
                            {` ${toPersianNum(selectedCommodity.name)}`}
                          </>
                        </span>
                      </div>

                      <div className="col-6 text-left offer-list-text">
                        <span className="">
                          {new Intl.NumberFormat("fa").format(
                            li["offered_price"]
                          )}
                          {" تومان "}
                        </span>
                      </div>
                    </div>
                  ))
                : showBuy && (
                    <div className="no-order-accepted">
                      هیچ سفارشی ثبت نشده است
                    </div>
                  )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
